import styled from "@emotion/styled";
import _ from 'lodash';
import * as React from 'react';
import FontAwesome from "react-fontawesome";
import { ADDFUNC, ADDPRED, FROM, FUNCTION, PREDICATE, TO } from "./ConstantNames";
import { canUseNameForGivenArityAndType, functionIsAlreadyDefinedForGivenFunction, getAvailableLanguageElementForGivenArity, setPredFuncBadNameIfRegexViolated } from "./functions";
import { BinaryLabelModel } from "../labels/binary/BinaryLabelModel";
import { Button } from "react-bootstrap";
export const DropDownModel = styled.div`
		width: 100%;
		pointer-events: ${p => p.pointerEvents};
		cursor: ${p => p.cursor};
		background-color: green;
		border-radius: 5px;
		font-family: sans-serif;
		font-weight: bold;
		color: black;
		overflow: visible;
		font-size: 13px;
		border: solid 2px black;
	`;
export const DropDownPorts = styled.div`
		display: flex;
		background-image: linear-gradient(rgba(256, 256, 256, 0.9), rgba(256, 256, 256, 0.9));
	`;
export const DropDownTitleName = styled.div`
		width: 100%;
		flex-grow: 1;
		padding: 3px 3px;
		font-size:11px;
		text-align:center;
		cursor: context-menu;
	`;
export const DropDownContainer = styled.div`
		width: auto;
		display: flex;
		flex-direction: column;
		flex: 1 0 0;
	`;
export const DropDownInputElement = styled.div`
		width: 100%;
		flex-grow: 1;
		padding: 3px 3px;
	`;
export const DropDownRowContainer = styled.div`
		display: flex;
		flex-direction: row;
		flex: 1 0 0;
	`;
export const DropDownLanguageElement = styled.div`
		min-width: 2em;
		width: 100%;
		height: 20px;
		background: rgba(white, 0.1);
		color: black;
		text-align:center;
	`;
export class DropDownMenuWidget extends React.Component {
  constructor(props) {
    super(props);
    this.generatePredicateComponent = this.generatePredicateComponent.bind(this);
    this.generateFunctionComponent = this.generateFunctionComponent.bind(this);
    this.setStateBadNameForLanguageElement = this.setStateBadNameForLanguageElement.bind(this);
    this.clearTextInput = this.clearTextInput.bind(this);
    this.state = {
      badNameForLanguageElement: true,
      canAddAsFunction: true,
      canAddAsPredicate: true,
      inputTitle: "Zadaj názov pre predikát alebo funkciu",
      predicateButtonTitle: "Pridaj nový predikát",
      functionButtonTitle: "Pridaj novú funkciu"
    };
  }

  setStateBadNameForPredFunc(elementName) {
    if (setPredFuncBadNameIfRegexViolated(elementName, this.setStateBadNameForLanguageElement)) {
      this.setState({
        inputTitle: "Zadaný názov nie je v správnom tvare"
      });
      return true;
    }

    this.setState({
      inputTitle: "Zadaj názov pre predikát alebo funkciu"
    });
    return false;
  }

  generatePredicateComponent(elementObject) {
    return this.generateAvailableLanguageElement(elementObject, PREDICATE);
  }

  setStateBadNameForLanguageElement(bool) {
    this.setState({
      badNameForLanguageElement: bool
    });
  }

  generateFunctionComponent(elementObject) {
    return this.generateAvailableLanguageElement(elementObject, FUNCTION);
  }

  generateAvailableLanguageElement = (languageElement, type) => {
    let alreadyDefined;

    if (type === FUNCTION) {
      if (this.props.arity !== "2") {
        alreadyDefined = functionIsAlreadyDefinedForGivenFunction(this.props.model.getNodeParameters(), this.props.model.getFunctionValue(), languageElement + "/" + (parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps());
      } else {
        alreadyDefined = functionIsAlreadyDefinedForGivenFunction(this.props.model.getNodeParameters(FROM), this.props.model.getFunctionValue(FROM), languageElement + "/" + (parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps()) && functionIsAlreadyDefinedForGivenFunction(this.props.model.getNodeParameters(TO), this.props.model.getFunctionValue(TO), languageElement + "/" + (parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps());
      }
    }

    return /*#__PURE__*/React.createElement(DropDownRowContainer, {
      key: languageElement
    }, /*#__PURE__*/React.createElement(DropDownLanguageElement, null, languageElement), /*#__PURE__*/React.createElement(Button, {
      className: 'btn-graph',
      variant: type === PREDICATE ? "outline-success" : !alreadyDefined ? "outline-success" : "outline-danger",
      disabled: type === FUNCTION && alreadyDefined,
      title: type === FUNCTION && alreadyDefined ? "Funkcia nemôže byť viackrát definovaná pre rovnaký(é) parameter(tre)" : "Pridaj " + (type === PREDICATE ? "predikát" : "funkciu"),
      onClick: () => {
        if (type === PREDICATE) {
          this.props.model.addPredicate(languageElement);
        } else {
          if (!alreadyDefined) {
            this.props.model.addFunction(languageElement);
          }
        }

        this.props.engine.repaintCanvas();
      }
    }, /*#__PURE__*/React.createElement(FontAwesome, {
      name: "fas fa-plus"
    })));
  };

  setLockedParentIfNeeded(bool) {
    if (this.props.model instanceof BinaryLabelModel) {
      this.props.model.setLockedParent(bool);
    }
  }

  componentDidMount() {
    //will re-render link so the position will be correct
    if (this.props.model instanceof BinaryLabelModel) {
      // @ts-ignore
      this.props.model.getParent().increaseChangeCounter();
      this.props.engine.repaintCanvas();
    }
  }

  componentWillUnmount() {
    this.props.model.getReduxProps()["focusOnBodyElement"]();
  }

  setCanUseForGivenType(type, elementName) {
    if (canUseNameForGivenArityAndType(elementName, type === PREDICATE ? this.props.arity : (parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps(), type)) {
      if (type === PREDICATE) {
        this.setState({
          canAddAsPredicate: true,
          predicateButtonTitle: "Pridaj nový predikát"
        });
      } else {
        this.setState({
          canAddAsFunction: true,
          functionButtonTitle: "Pridaj novú funkciu"
        });

        if (this.props.arity !== "2") {
          if (functionIsAlreadyDefinedForGivenFunction(this.props.model.getNodeParameters(), this.props.model.getFunctionValue(), this.textInput.value + "/" + (parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps())) {
            this.setState({
              canAddAsFunction: false,
              functionButtonTitle: "Funkcia nemôže byť viackrát definovaná pre rovnaký(é) parameter(tre)"
            });
          }
        } else {
          if (functionIsAlreadyDefinedForGivenFunction(this.props.model.getNodeParameters(FROM), this.props.model.getFunctionValue(FROM), this.textInput.value + "/" + (parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps()) && functionIsAlreadyDefinedForGivenFunction(this.props.model.getNodeParameters(TO), this.props.model.getFunctionValue(TO), this.textInput.value + "/" + (parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps())) {
            this.setState({
              canAddAsFunction: false,
              functionButtonTitle: "Funkcia nemôže byť viackrát definovaná pre rovnaký(é) parameter(tre)"
            });
          }
        }
      }
    } else {
      if (type === PREDICATE) {
        this.setState({
          canAddAsPredicate: false,
          predicateButtonTitle: "Predikát nejde pridať, predikát alebo funkcia s daným menom už existuje pre iný typ alebo pre inú aritu"
        });
      } else {
        this.setState({
          canAddAsFunction: false,
          functionButtonTitle: "Funkciu nejde pridať, predikát alebo funkcia s daným menom už existuje pre iný typ alebo pre inú aritu"
        });
      }

      return;
    }
  }

  clearTextInput() {
    this.textInput.value = "";
    this.setState({
      badNameForLanguageElement: true,
      canAddAsFunction: true,
      canAddAsPredicate: true
    });
    this.props.engine.repaintCanvas();
  }

  addGivenInputElement(type) {
    if (!this.setStateBadNameForPredFunc(this.textInput.value.replace(/\s/g, "")) && canUseNameForGivenArityAndType(this.textInput.value, type === PREDICATE ? this.props.arity : (parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps(), type)) {
      if (type === PREDICATE) {
        this.props.model.addPredicate(this.textInput.value);
      } else {
        if (!this.state.canAddAsFunction) {
          return;
        }

        this.props.model.addFunction(this.textInput.value);
      }

      this.clearTextInput();
    }
  }

  render() {
    let funcArity = parseInt(this.props.arity) - 1;
    return /*#__PURE__*/React.createElement(DropDownModel, {
      pointerEvents: this.props.model.isEditable() ? "auto" : "none",
      cursor: this.props.model.isEditable() ? "pointer" : "move"
    }, /*#__PURE__*/React.createElement(DropDownPorts, null, /*#__PURE__*/React.createElement(DropDownContainer, null, /*#__PURE__*/React.createElement(DropDownTitleName, {
      title: "Zoznam použiteľných predikátov pre aritu " + this.props.arity
    }, "Pred"), _.map(Array.from(getAvailableLanguageElementForGivenArity(this.props.arity, this.props.model.getReduxProps(), this.props.model.getPredicates(), PREDICATE)), this.generatePredicateComponent), funcArity !== 0 ? /*#__PURE__*/React.createElement(DropDownTitleName, {
      title: "Zoznam použiteľných funkcií pre aritu " + funcArity
    }, "Func") : null, funcArity !== 0 ? _.map(Array.from(getAvailableLanguageElementForGivenArity((parseInt(this.props.arity) - 1).toString(), this.props.model.getReduxProps(), this.props.model.getFunctions(), FUNCTION)), this.generateFunctionComponent) : null, /*#__PURE__*/React.createElement(DropDownInputElement, null, /*#__PURE__*/React.createElement(DropDownRowContainer, {
      key: "lastPredicateOption"
    }, /*#__PURE__*/React.createElement("input", {
      title: this.state.inputTitle,
      onChange: e => {
        let elName = e.target.value.replace(/\s/g, "");
        this.props.setStateInputElementTextLength(e.target.value.length);
        this.setStateBadNameForPredFunc(elName);
        this.setCanUseForGivenType(PREDICATE, elName);

        if (this.props.arity !== "1") {
          this.setCanUseForGivenType(FUNCTION, elName);
        }
      },
      ref: input => this.textInput = input,
      onFocus: () => {
        this.props.model.setLocked(true);
        this.setLockedParentIfNeeded(true);
      },
      onBlur: () => {
        this.props.model.setLocked(false);
        this.setLockedParentIfNeeded(false);
      },
      onKeyDown: e => {
        if (e.key === "Escape") {
          this.props.closeDropDown();
        } else if (e.key === "Enter" && funcArity === 0) {
          this.addGivenInputElement(PREDICATE);
        }
      },
      placeholder: funcArity !== 0 ? "Add pred/func" : "Add predicate",
      style: {
        width: (this.props.widthOfInputElement === 1 ? 2 : this.props.widthOfInputElement) + "ch",
        height: 20 + "px",
        border: this.state.badNameForLanguageElement ? "1px solid red" : "1px solid black"
      }
    }), /*#__PURE__*/React.createElement(Button, {
      className: 'btn-graph',
      variant: this.state.canAddAsPredicate ? "outline-success" : "outline-danger",
      disabled: !this.state.canAddAsPredicate,
      title: this.state.predicateButtonTitle,
      onClick: () => {
        this.addGivenInputElement(PREDICATE);
      }
    }, ADDPRED), funcArity !== 0 ? /*#__PURE__*/React.createElement(Button, {
      className: 'btn-graph',
      variant: this.state.canAddAsFunction ? "outline-success" : "outline-danger",
      disabled: !this.state.canAddAsFunction,
      title: this.state.functionButtonTitle,
      onClick: () => {
        this.addGivenInputElement(FUNCTION);
      }
    }, ADDFUNC) : null)))));
  }

}